import React, { useEffect } from "react";
import { useActiveWorkspace } from "@hooks/useActiveWorkspace";
import { DEFAULT_SORT, getSortExpression } from "./useSort";
import { preloadTransactionsQuery } from "./useTransactionsQuery";
import { useTransactionsPageReady } from "./useTransactionsPageReady";
import { useTransactionsPageOpeningView } from "./views/useTransactionsPageOpeningView";

function usePrefetchTransactions() {
    const { view } = useTransactionsPageOpeningView();
    const workspace = useActiveWorkspace();
    const workspaceId = workspace?.id ?? "";

    useEffect(() => {
        if (view) {
            preloadTransactionsQuery({
                filters: {
                    ...view.filters,
                    entityIds: view.filters.entityIds ?? [],
                },
                page: 1,
                sort: getSortExpression(DEFAULT_SORT),
                workspaceId,
                skipCount: true,
            });
        }
    }, [view, workspaceId]);
}

const PrefetchTransactionsRunner: React.FC = () => {
    usePrefetchTransactions();
    return null;
};

/**
 * Prefetches the transactions list query. Renders nothing.
 *
 * Only mounted once the Transactions page itself would render, so it resolves
 * the same default view the page opens on rather than one built from the
 * optimistic GL-first state or unloaded categories. It only reads the view
 * caches: the page owns writing them.
 */
export const TransactionsPrefetcher: React.FC = () => {
    const isReady = useTransactionsPageReady();

    if (!isReady) {
        return null;
    }

    return <PrefetchTransactionsRunner />;
};
